import React, { useState } from 'react';
import { CalendarIcon, ClockIcon, MapPinIcon, UsersIcon, CheckIcon, XIcon } from 'lucide-react';
interface EventCardProps {
  title: string;
  date: string;
  time: string;
  location: string;
  attendees: number;
  maxAttendees?: number;
  id?: string;
}
const EventCard = ({
  title,
  date,
  time,
  location,
  attendees,
  maxAttendees,
  id = '1'
}: EventCardProps) => {
  const [attendance, setAttendance] = useState<'attending' | 'notAttending' | null>(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedback, setFeedback] = useState('');
  const handleAttendance = (status: 'attending' | 'notAttending') => {
    setAttendance(status);
    if (status === 'notAttending') {
      setShowFeedback(true);
    } else {
      setShowFeedback(false);
    }
  };
  const handleSubmitFeedback = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you for your feedback!');
    setShowFeedback(false);
  };
  return <div className="border border-gray-300 rounded-lg p-4 mb-3" data-id="element-104">
      <h3 className="font-bold" data-id="element-105">{title}</h3>
      <div className="flex items-center mt-2 text-sm text-gray-600" data-id="element-106">
        <CalendarIcon className="w-4 h-4 mr-1" data-id="element-107" />
        <span data-id="element-108">{date}</span>
      </div>
      <div className="flex items-center mt-1 text-sm text-gray-600" data-id="element-109">
        <ClockIcon className="w-4 h-4 mr-1" data-id="element-110" />
        <span data-id="element-111">{time}</span>
      </div>
      <div className="flex items-center mt-1 text-sm text-gray-600" data-id="element-112">
        <MapPinIcon className="w-4 h-4 mr-1" data-id="element-113" />
        <span data-id="element-114">{location}</span>
      </div>
      <div className="flex justify-between items-center mt-3" data-id="element-115">
        <div className="flex items-center text-sm text-gray-600" data-id="element-116">
          <UsersIcon className="w-4 h-4 mr-1" data-id="element-117" />
          <span data-id="element-118">
            {attendees} {maxAttendees ? `/ ${maxAttendees}` : ''} attending
          </span>
        </div>
        {attendance ? <div className="flex items-center" data-id="element-119">
            <span className="text-xs mr-2" data-id="element-120">
              {attendance === 'attending' ? 'You are attending' : 'Not attending'}
            </span>
            <button onClick={() => setAttendance(null)} className="text-xs border border-gray-300 rounded-md px-2 py-1" data-id="element-121">
              Change
            </button>
          </div> : <div className="flex space-x-2" data-id="element-122">
            <button onClick={() => handleAttendance('attending')} className="border border-gray-400 rounded-md px-3 py-1 text-sm flex items-center" data-id="element-123">
              <CheckIcon className="w-3 h-3 mr-1" data-id="element-124" />
              Attended
            </button>
            <button onClick={() => handleAttendance('notAttending')} className="border border-gray-400 rounded-md px-3 py-1 text-sm flex items-center" data-id="element-125">
              <XIcon className="w-3 h-3 mr-1" data-id="element-126" />
              Missed
            </button>
          </div>}
      </div>
      {showFeedback && <div className="mt-3 border-t border-gray-200 pt-3" data-id="element-127">
          <form onSubmit={handleSubmitFeedback} data-id="element-128">
            <label className="block text-sm font-medium mb-1" data-id="element-129">
              Share your thoughts or why you missed the event
            </label>
            <textarea value={feedback} onChange={e => setFeedback(e.target.value)} className="w-full p-2 border border-gray-300 rounded-md text-sm" rows={2} placeholder="Your feedback helps improve future events..." data-id="element-130" />
            <div className="flex justify-end mt-2" data-id="element-131">
              <button type="button" onClick={() => setShowFeedback(false)} className="text-xs border border-gray-300 rounded-md px-3 py-1 mr-2" data-id="element-132">
                Cancel
              </button>
              <button type="submit" className="text-xs bg-gray-800 text-white rounded-md px-3 py-1" data-id="element-133">
                Submit Feedback
              </button>
            </div>
          </form>
        </div>}
    </div>;
};
export default EventCard;